import type { HelpFile } from '../../types/help'
import { EnforcementObjectDetailTestIds } from '../../../testids/EnforcementObjectDetailTestIds'

export const enforcementObjectDetailHelp: HelpFile = {
  docPage: '/docs/target-systems/enforcement-objects',
  texts: {
    [EnforcementObjectDetailTestIds.enforcementObjectDetailPage]:
      'Details zu einem Enforcement-Objekt — das technische Artefakt (Gruppe, Rolle, ACL-Eintrag), das in einem Zielsystem Zugriff gewährt.',
    [EnforcementObjectDetailTestIds.cardEnforcementObjectDetails]: null,
    [EnforcementObjectDetailTestIds.cardTitleAccessProfiles]:
      'Zugriffsprofile, die dieses Enforcement-Objekt in ihrer Berechtigungsmenge enthalten.',
    [EnforcementObjectDetailTestIds.cardTitleRelatedEntities]: null,
    [EnforcementObjectDetailTestIds.colName]: null,
    [EnforcementObjectDetailTestIds.colResource]: null,
    [EnforcementObjectDetailTestIds.colRiskLevel]:
      'Risikoeinstufung dieses Enforcement-Objekts.',
    [EnforcementObjectDetailTestIds.colStatus]: null,
    [EnforcementObjectDetailTestIds.linkResourceDetail]: null,
    [EnforcementObjectDetailTestIds.linkSystemDetail]: null,
  },
}
